// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".program-main[data-v-3f96ca3f]{font-weight:700;font-size:16px;line-height:24px}.program-content[data-v-3f96ca3f]{font-style:normal;font-weight:400;font-size:12px;line-height:18px}", ""]);
// Exports
module.exports = exports;
